export const reviewsMeta = {
  rating: "4,5",
  count: 155,
  source: "Tripadvisor",
  url: "https://www.tripadvisor.it/Restaurant_Review-g644261-d11045156-Reviews-U_Magazin-Carloforte_Province_of_Sulcis_Iglesiente_Sardinia.html",
};

export const reviews = [
  {
    author: "Ilnico7",
    date: { it: "Settembre 2026", en: "September 2026" },
    it: "Prima sera a Carloforte e subito un inizio col botto. Locale gestito da due ragazze gentilissime e sorridenti, che ci hanno guidato nella scelta di piatti e vini con competenza. Ottimi piatti della tradizione, atmosfera piacevolissima.",
    en: "First night in Carloforte and an immediate start with a bang. Run by two very kind and smiling girls who guided us through dishes and wines with wisdom. Excellent traditional dishes and a very pleasant atmosphere.",
  },
  {
    author: "Lorenzo C.",
    date: { it: "Agosto 2026", en: "August 2026" },
    it: "Location bellissima, ma soprattutto piatti davvero buoni, cucinati come una volta. La fregola da 10, i culurgiones pure. Vini ottimi e ragazze simpaticissime. Se siete a Carloforte non potete perdervi una cena qui.",
    en: "Very beautiful location, but above all truly good dishes, cooked like in the old days. Fregola was a 10, culurgiones the same. Very good wines and really nice girls. If you are in Carloforte, you cannot miss a dinner here.",
  },
  {
    author: "Anna S.",
    date: { it: "Luglio 2026", en: "July 2026" },
    it: "Cucina eccezionale, porzioni generose, vino di qualità consigliato con esperienza. Ambiente caldo e accogliente, elegante nella sua semplicità. Come essere a casa.",
    en: "Exceptional cuisine, generous portions, quality wine recommended with experience. A warm, welcoming environment, elegant in its simplicity. Like being at home.",
  },
  {
    author: "Annamaria R.",
    date: { it: "Giugno 2026", en: "June 2026" },
    it: "Una sera non basta per apprezzare cucina e atmosfera. Ottima selezione di vini, un ambiente tranquillo che favorisce le chiacchiere tra amici, con una musica di sottofondo discreta e a tratti rétro.",
    en: "One evening is not enough to appreciate the cuisine and atmosphere. Excellent wine selection, a quiet environment that invites conversation with friends, with discreet, occasionally retro background music.",
  },
  {
    author: "Emilio B.",
    date: { it: "Giugno 2026", en: "June 2026" },
    it: "Un angolo di piacevole intimità. Staff sorridente e dal gusto musicale squisito, una cucina fatta di materie prime ricercate e rielaborate con semplicità. La cantina è molto interessante.",
    en: "A corner of pleasant intimacy. Smiling staff with exquisite musical taste, a cuisine built on carefully sourced ingredients reworked simply. The wine cellar is very interesting.",
  },
  {
    author: "Flavia B.",
    date: { it: "Settembre 2025", en: "September 2025" },
    it: "Ottimi la fregula e i culurgiones che ci sono stati consigliati. Eccellenti anche i dolci. Grande professionalità e competenza. Consigliatissimo.",
    en: "Excellent fregula and culurgiones, just as recommended. The desserts are also excellent. Great professionalism and competence. Highly recommended.",
  },
  {
    author: "Barbara D.",
    date: { it: "Settembre 2025", en: "September 2025" },
    it: "Un posto delizioso, con un'ampia selezione di buoni vini locali e piatti tipici serviti su tavole decorate. Si può cenare nel giardino sul retro o con vista sul porto. Una cena davvero speciale.",
    en: "Lovely place with a large selection of local good wine and typical food served on decorated tables. You can eat in the back garden or with a port view. So nice special dinner tonight!",
  },
  {
    author: "Alessandra B.",
    date: { it: "Giugno 2025", en: "June 2025" },
    it: "Locale curato in ogni dettaglio, cucina eccellente che parte da ottime materie prime. Tartare di tonno squisita e una fregola spettacolare. I dolci meritano una menzione speciale: da 10 e lode.",
    en: "A spotless, tastefully decorated place, with excellent cuisine built on excellent raw materials. An exquisite tuna tartare and a spectacular fregola. The desserts deserve a special mention: top marks.",
  },
];
